export default __webpack_public_path__ + "5fffc8c75312388f9397c494ec949bbb.png";